// @flow

import React from "react";
import { localize } from "redux-i18n";
import { ColumnsContainer, SectionComponent, SchemaForm, Button } from "@components";

import { split } from "@transformers/schema";
import type { PropertiesSchema } from "@types";
import type { ReportingParametersData } from "@modules/service/reducer/reporting-parameters/types";
import uiSchema from "./ui-schema";

type Props = $Exact<{
  clientId: ?number,
  data: ReportingParametersData,
  schema: PropertiesSchema,
  updateReportingParameters: Function,
  ...PropsFromLocalize,
}>;

type ComponentState = $Exact<{
  edit: boolean,
}>;

export class ReportingParametersColumns extends React.Component<Props, ComponentState> {
  constructor(props: Props) {
    super(props);
    // Class components needs constructor for accessing the SchemaForm's ref
    this.formRef = React.createRef();
  }
  state = {
    edit: false,
  };

  toggleEdit = () => {
    this.setState({
      edit: !this.state.edit,
    });
  };

  cancelEdit = () => {
    this.setState({
      edit: false,
    });
  };

  submitForm = () => {
    this.formRef.current.submit();
  };

  handleSubmit = (formData: Object) => {
    formData.bv12_trend = formData.bv12Trend; // snakecase library we use does not properly handles this case
    delete formData.bv12Trend;
    this.props.updateReportingParameters({
      clientId: this.props.clientId,
      formData,
    });
    this.toggleEdit();
  };

  get data() {
    return {
      ...this.props.data,
      reportingPeriods: "CALENDAR_MONTH",
      salaryCostAbsenceTrend: false,
      employeeAbsenceRates: true,
      rtwIncludedAbsenceRates: true,
      absenceRateCalculationType: "WORKING_HOURS",
      descriptionReasonSuspectedUnderReporting: "Not Used",
      descriptionReasonCostAbsence: "Not Used",
    };
  }

  get uiSchema() {
    return uiSchema(this.props.t);
  }

  render() {
    return (
      <SectionComponent
        title={<h5>{this.props.t("REPORT_PARAMETERS")}</h5>}
        rightLink={
          <div>
            {!this.state.edit ? (
              <Button materialIcon="edit" onClick={this.toggleEdit}>
                {this.props.t("EDIT")}
              </Button>
            ) : (
              <div className="d-flex">
                <Button color="secondary" onClick={this.cancelEdit}>
                  {this.props.t("CANCEL")}
                </Button>
                <Button
                  materialIcon="replay_circle_filled"
                  className="ml-2"
                  onClick={this.submitForm}
                >
                  {this.props.t("SUBMIT")}
                </Button>
              </div>
            )}
          </div>
        }
      >
        <SchemaForm
          ref={this.formRef}
          schema={this.props.schema}
          formData={this.data}
          onSubmit={this.handleSubmit}
          uiSchema={this.uiSchema}
          readonly={!this.state.edit}
          externalSubmit
          boxGrid
        />
      </SectionComponent>
    );
  }
}

export default localize()(ReportingParametersColumns);
